<div class="toolbar-wrap tw-flex">
  <a
    (click)="toggleFiltersVisibility()"
    class="filters-toggle-link"
    *ngIf="filterList?.length > showHideFilterLevelLimit"
  >
    <span>
      {{
        showAllFilters
          ? ('monitoring.filters.hideAllFilters' | translate)
          : ('monitoring.filters.showAllFilters' | translate)
      }}
    </span>
    <ui-svg-icon [name]="showAllFilters ? iconNameList.Up : iconNameList.Down" [width]="18" class="arrow-icon">
    </ui-svg-icon>
  </a>

  <mat-chip-listbox *ngIf="showAllFilters && filterList?.length">
    <ng-container *ngFor="let group of filterList">
      <ng-container *ngIf="group.values.length > 1; else singleFilterTemplate">
        <mat-chip-option
          class="filter-group-item"
          [selectable]="false"
          [removable]="true"
          (removed)="listFiltersService.resetFilterGroup$.emit(group.title)"
        >
          {{ ('monitoring.filters.' + group.title | translate) + ' (' + group.values.length + ')' }}
          <ui-svg-icon [name]="iconNameList.Close" [width]="18" matChipRemove></ui-svg-icon>
        </mat-chip-option>
      </ng-container>

      <ng-template #singleFilterTemplate>
        <mat-chip-option
          *ngFor="let item of group.values"
          [selectable]="false"
          [removable]="true"
          (removed)="listFiltersService.resetFilterGroup$.emit(group.title)"
        >
          <ng-container [ngSwitch]="true">
            <ng-container *ngSwitchCase="isLabelBasedFilter(group.title)">
              {{ 'monitoring.filters.' + group.title | translate }}
            </ng-container>
            <ng-container *ngSwitchCase="translatedFilterTitles.has(item)">
              {{ translatedFilterTitles.get(item) | translate }}
            </ng-container>
            <ng-container *ngSwitchCase="isDateRangeFilter(item)">
              {{ 'monitoring.filters.' + item | translate }}
            </ng-container>
            <ng-container *ngSwitchCase="isCollectionBasedFilter(group.title)">
              {{ 'monitoring.filters.collection' | translate }}
            </ng-container>
            <ng-container *ngSwitchCase="isRoleBasedFilter(group.title)"> {{ item | roleGroupPipe }}</ng-container>
            <ng-container *ngSwitchCase="isCountryBasedFilter(group.title)">
              {{ item | countriesCodeToName }}
            </ng-container>
            <ng-container *ngSwitchDefault>
              {{ item?.value || item | monitoringFilterAdjustUiPipe : group.title }}
            </ng-container>
          </ng-container>
          <ui-svg-icon [name]="iconNameList.Close" [width]="18" matChipRemove></ui-svg-icon>
        </mat-chip-option>
      </ng-template>
    </ng-container>

    <mat-chip-option
      *ngIf="filterList.length"
      [attr.test-id]="'clear-all-button'"
      [selectable]="false"
      (click)="listFiltersService.resetFilterForm$.emit()"
      (removed)="listFiltersService.resetFilterForm$.emit()"
      class="reset-filters-btn"
    >
      {{ 'common.button.resetAllFilters' | translate }}
      <ui-svg-icon [name]="iconNameList.Delete" [width]="18" class="tw-opacity-40 tw-ml-2" matChipRemove></ui-svg-icon>
    </mat-chip-option>
  </mat-chip-listbox>
</div>
